var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notify-list"},_vm._l((_vm.$store.state.notifyApp.notifies),function(noty,index){return _c(noty.component,{key:index,tag:"component",attrs:{"text":noty.text},on:{"close":function($event){return _vm.$store.dispatch('removeNotify', index)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }